import { bindSwiperAutoplayToViewport } from "../utils/bind-swiper-autoplay-to-viewport.js";

const TABLET_MAX_PX = 1260;
const TABLET_MQ = `(max-width: ${TABLET_MAX_PX}px)`;

export function initCoLocatedLogosSlider() {
  const sections = document.querySelectorAll(".js-co-located-logos");
  if (!sections.length || typeof Swiper === "undefined") return;

  sections.forEach((sectionEl) => {
    const sliderEl = sectionEl.querySelector(".co-located-logos__slider");
    if (!sliderEl) return;

    let swiperInstance = null;
    let releaseViewport = () => {};
    const tabletQuery = window.matchMedia(TABLET_MQ);

    const initSwiper = () => {
      if (swiperInstance) return;

      swiperInstance = new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 500,
        grabCursor: true,
        watchOverflow: true,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
      });

      releaseViewport();
      releaseViewport = bindSwiperAutoplayToViewport(swiperInstance);
    };

    const destroySwiper = () => {
      if (!swiperInstance) return;
      releaseViewport();
      releaseViewport = () => {};
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    };

    const handleViewportChange = () => {
      if (tabletQuery.matches) {
        initSwiper();
      } else {
        destroySwiper();
      }
    };

    handleViewportChange();

    if (typeof tabletQuery.addEventListener === "function") {
      tabletQuery.addEventListener("change", handleViewportChange);
    } else {
      tabletQuery.addListener(handleViewportChange);
    }
  });
}
